import { all, takeLatest } from 'redux-saga/effects'
import types from '../actions/types'
import { SKILLS } from 'helpers/onboarding'
import {trackEvent} from 'helpers/tracking'

export default (/*api*/) => {

  function * showSkill({ key }) {
    try {
      const skill = SKILLS[key]
      if (skill) trackEvent(`Skills: ${skill.label}`, "Initiated Skill", skill.label)
    } catch (e) {
      console.error(e)
    }
  }

  function * hideSkill({ key }) {
    try {
      const skill = SKILLS[key]
      if (skill) trackEvent(`Skills: ${skill.label}`, "Cancelled Skill", "(close)")
    } catch (e) {
      console.error(e)
    }
  }

  function * skillPage({ key, page }) {
    try {
      const skill = SKILLS[key]
      if (skill) trackEvent(`Skills: ${skill.label}`, `Progressed Skill: ${page + 1}`, "(step)")
    } catch (e) {
      console.error(e)
    }
  }

  function * finishSkill({ key }) {
    try {
      const skill = SKILLS[key]
      if (skill) trackEvent(`Skills: ${skill.label}`, "Finished Skill", "(completed)")
    } catch (e) {
      console.error(e)
    }
  }


  function * watcher() {
    yield all([
      takeLatest(types.ONBOARDING_SKILL_SHOW, showSkill),
      takeLatest(types.ONBOARDING_SKILL_HIDE, hideSkill),
      takeLatest(types.ONBOARDING_SKILL_PAGE, skillPage),
      takeLatest(types.ONBOARDING_SKILL_FINISH, finishSkill),
    ])
  }

  return {
    watcher,
  }
}
